import { environment } from '@env/environment';
import { MODULE_ENV_FLAGS } from './roles';

export interface ModuleVisibility {
  can(module: string): boolean;
  isSuperuser: boolean;
  isAdmin: boolean;
  isEditor: boolean;
  isErfasser: boolean;
}

export function canSeeModule(module: string, vis: ModuleVisibility): boolean {
  if (!vis.can(module)) {
    return false;
  }
  const envFlag = MODULE_ENV_FLAGS[module];
  if (envFlag && !(environment as Record<string, unknown>)[envFlag]) {
    return false;
  }
  return true;
}

export function canSeeDashboard(vis: ModuleVisibility): boolean {
  return vis.isAdmin || vis.isEditor || vis.isErfasser || vis.can('transfer');
}

export function canSeeSettings(vis: ModuleVisibility): boolean {
  return vis.isAdmin;
}

export function canSeeDienstnehmer(vis: ModuleVisibility): boolean {
  // Superuser-only, never for regular admins, even if enabled via environment.
  return environment.showDienstnehmer && vis.isSuperuser;
}

/** Whether a help topic should be shown for the current user. */
export function canSeeHelpPage(pageId: string, vis: ModuleVisibility): boolean {
  switch (pageId) {
    case 'dashboard':
      return canSeeDashboard(vis);
    case 'transfer':
      return vis.can('transfer');
    case 'bulk-import':
      return canSeeModule('bulk-import', vis);
    case 'mandate':
      return vis.can('mandate');
    case 'zahlungsabgleich':
      return canSeeModule('zahlungsabgleich', vis);
    case 'vstv':
      return vis.can('vstv');
    case 'reports':
      return vis.can('reports');
    case 'stammdaten':
    case 'settings':
      return canSeeSettings(vis);
    case 'dienstnehmer':
      return canSeeDienstnehmer(vis);
    case 'support':
      return true;
    default:
      return true;
  }
}
